// NOTE: Compatibility wrapper for legacy logger interface.
// Translates old-style calls like global.logger.error(msg, data, error)
// to new-style calls using LogPayload objects. Can be deleted once all
// old logger usages are migrated.
export class LegacyLogger {
    constructor(beeyLogger) {
        this.beeyLogger = beeyLogger;
    }
    info(msgOrError, data, error) {
        this.log('info', msgOrError, data, error);
    }
    warn(msgOrError, data, error) {
        this.log('warn', msgOrError, data, error);
    }
    error(msgOrError, data, error) {
        this.log('error', msgOrError, data, error);
    }
    log(level, msgOrError, data, error) {
        const { msg, actualData, actualError } = this.normalizeArgs(msgOrError, data, error);
        const sanitizedData = this.sanitizeData(actualData);
        this.beeyLogger[level](msg, sanitizedData, actualError);
    }
    // NOTE: Normalizes the varied argument patterns of the old logger into a single format.
    // It handles two main legacy call signatures:
    // 1. logger.info('Message', { data }, error)
    // 2. logger.error(error, { data })
    normalizeArgs(msgOrError, data, error) {
        if (typeof msgOrError !== 'string') {
            return {
                msg: msgOrError instanceof Error ? msgOrError.message : 'Error occurred',
                actualData: data,
                actualError: msgOrError,
            };
        }
        return { msg: msgOrError, actualData: data, actualError: error };
    }
    // NOTE: Ensures that all values in the data object are primitives
    // (string, number, boolean, null).
    //  Complex types like objects or arrays are converted to a string representation
    //  to prevent issues during log serialization and transmission.
    sanitizeData(data) {
        if (!data) {
            return undefined;
        }
        return Object.keys(data).reduce((acc, key) => {
            const value = data[key];
            let sanitizedValue;
            if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean' || value === null) {
                sanitizedValue = value;
            }
            else {
                try {
                    sanitizedValue = JSON.stringify(value);
                }
                catch (_a) {
                    sanitizedValue = String(value);
                }
            }
            return Object.assign(Object.assign({}, acc), { [key]: sanitizedValue });
        }, {});
    }
}
